export default class RegionType {
  static get District () { return 'district' } // район
  static get City () { return 'crm' } // город, населенный пункт
}
